module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/NonCompatibile.e9964a87.png";